<template>
  <div>
    <div class="informativeitem" :class="{ 'informativeitem--close': close }">
      <div class="informativeitem__bar" @click="toggle">
        <div class="informativeitem__icon">
          <img :src="icon" :alt="title" :title="title" />
        </div>
        <div class="informativeitem__title">{{ title }}</div>
      </div>
      <div class="informativeitem__items">
        <div class="informativeitem__item" v-for="(item, index) in items" :key="index">
          {{ item }}
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "informativeitem",
  props: {
    items: {
      default: []
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    toggle() {
      this.close = !this.close;
    }
  },
  created() {
    this.index === 0 ? (this.close = false) : "";
  },
  data: () => ({
    close: true
  })
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";
.informativeitem {
  $root: &;

  text-align: center;
  width: 25.6rem;

  @media (max-width: $max-sm) {
    width: 100%;
    text-align: left;
    position: relative;
    border-top: 1px solid #c5c5c5;
    margin-bottom: -1px;
    overflow: hidden;
    border-bottom: 1px solid #c5c5c5;
    &--close {
      height: calc(5.3rem - 1px);
    }
  }

  &__icon {
    height: 5rem;
    width: 6rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    @media (min-width: $min-md) {
      margin: 0 auto;
    }
    @media (max-width: $max-sm) {
      margin-right: 1.8rem;
      height: 2.9rem;
      width: 3.9rem;
    }
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
  &__title {
    font-size: 2.9rem;
    font-weight: 900;
    line-height: 3.5rem;
    margin: 0.2rem 0 2rem;
    @media (max-width: $max-sm) {
      font-size: 1.7rem;
      margin: 0;
      line-height: 1.7rem;
    }
  }
  &__bar {
    @media (max-width: $max-sm) {
      display: flex;
      padding: 1.1rem 2.4rem;
      align-items: center;
      border-bottom: 1px solid #c5c5c5;
      position: relative;
      cursor: pointer;
      background: #f5f5f5;
      &::after {
        content: "";
        position: absolute;
        right: 2.4rem;
        background-image: url("../assets/icons/gray-triangle.svg");
        background-repeat: no-repeat;
        width: 1.5rem;
        height: 1.2rem;
        transform: rotate(0deg);
        #{$root}--close & {
          transform: rotate(180deg);
        }
      }
    }
  }
  &__items {
    @media (max-width: $max-sm) {
      padding: 1.5rem 8.3rem;
      background: #fff;
      border-bottom: 1px solid #c5c5c5;
      margin-bottom: -1px;
    }
  }
  &__item {
    font-size: 1.5rem;
    line-height: 3rem;
    @media (max-width: $max-sm) {
      font-size: 1.4rem;
      line-height: 2.3rem;
    }
  }
}
</style>
